module.exports = __webpack_public_path__ + "static/media/sacrifice1.e5e03a94.jpg";